import { useState, useRef, useEffect } from "react";
import {
  Circle,
  TileLayer,
  Marker,
  Popup,
  Polyline,
} from "react-leaflet";
import { useMap, useMapEvents } from 'react-leaflet';

import L from "leaflet";

import { HeatmapLayer } from 'react-leaflet-heatmap-layer-v3';
import { If, Then, Else, When } from 'react-if';


const home = [45.53132, -122.68091];
const lvcc_west_hall = [36.13427, -115.15732];
const lvccTileBounds = [[36.1280, -115.1660], [36.1400, -115.1480]];
const sampleLocation = (s) => [s.latitude, s.longitude, 1.0];
const defaultRadius = 25;

const WayPoint = L.divIcon({
  html: "🔹",
  className: "dummy", // Specify something to get rid of the default class.
});

const SelectedPoint = L.divIcon({
  html: "🔶",
  className: "dummy", // Specify something to get rid of the default class.
});

function houseIcon(zoom) {
  const size = Math.max(16, Math.min(42, Math.round(42 * Math.pow(1.4, zoom - 17))));
  return L.divIcon({
    html: `<span style="font-size:${size}px">🏠</span>`,
    className: "text-center",
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
}

const PirateFlag = L.divIcon({
  html: "🏴‍☠️",
  className: "display-4 text-center",
  iconSize: [56, 68],
});

const tileLayer = {
  attribution:
    '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  url: "https://{s}.tile.jawg.io/jawg-matrix/{z}/{x}/{y}{r}.png?access-token=s7Jaxor8MDBUEQ6Wz8l5vjpEPu5gfyJ3GEO8CstO3xVnU5mDfX38S4o4LHjyYRYQ",
  maxZoom: 22,
};

/*
const tileLayer = {
  attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
  url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
  maxZoom: 20,
};
*/

function MapGuts(props) {
  const { selectedIndex, displaySamples, view, follow = true, showHome = true, flyTo, onFlyComplete } = props;
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());

  useMapEvents({
    zoomend: () => setZoom(map.getZoom()),
  });

  const prevSamplesRef = useRef();
  useEffect(() => {
    if (follow && displaySamples.length > 0 && displaySamples !== prevSamplesRef.current) {
      const validPoints = displaySamples
        .filter(s => !isNaN(s.latitude) && !isNaN(s.longitude))
        .map(s => [s.latitude, s.longitude]);
      if (validPoints.length > 0) {
        map.fitBounds(validPoints, { padding: [20, 20], maxZoom: map.getZoom() });
      }
    }
    prevSamplesRef.current = displaySamples;
  }, [follow, displaySamples, map]);

  useEffect(() => {
    if (flyTo) {
      map.flyTo(flyTo, 17);
      if (onFlyComplete) onFlyComplete();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flyTo, map]);

  return (
    <>
      {process.env.NODE_ENV === 'development' && <div style={{
        position: 'absolute', top: 10, right: 10, zIndex: 1000,
        background: 'rgba(0,0,0,0.7)', color: 'white', padding: '4px 8px',
        borderRadius: 4, fontSize: 14, pointerEvents: 'none',
      }}>
        Zoom: {zoom}
      </div>}
      <When condition={showHome}>
        <Marker position={home} icon={houseIcon(zoom)} />
      </When>

      {zoom <= 17 && <Marker position={lvcc_west_hall} icon={PirateFlag}>
        <Popup className="justify-content-center">
          <h3>DEFCON</h3>
        </Popup>
      </Marker>}

      {selectedIndex > -1 ? (
        <Circle center={sampleLocation(displaySamples[selectedIndex])} radius={defaultRadius} />
      ) : null }

      <If condition={view === 'points'}>
      <Then>
        {displaySamples.map((s, index) => {
          const show = index < 10 || index === selectedIndex
          return (
            <Marker
              key={index}
              position={sampleLocation(s)}
              icon={selectedIndex === index ? SelectedPoint : WayPoint}
              keyboard={false}
              opacity={show ? 1.0 : 0.0}
            >
              <Popup>
                #{index + 1}: {s.who} @ {s.timestamp.toLocaleTimeString("en-US")}
              </Popup>
            </Marker>
          );
        })}
        <Polyline
          positions={displaySamples.slice(0, 5).map(sampleLocation)}
        />
        <Polyline
          positions={displaySamples.slice(4, 10).map(sampleLocation)}
          weight={2}
          opacity={0.75}
        />
        <Polyline
          positions={displaySamples.slice(9).map(sampleLocation)}
          weight={1}
          opacity={0.5}
        />
        {displaySamples[0] ? (
          <Circle center={sampleLocation(displaySamples[0])} radius={defaultRadius} />
        ) : null}
      </Then>
      <Else>
        <HeatmapLayer
          fitBoundsOnLoad
          fitBoundsOnUpdate
          points={displaySamples.map(sampleLocation)}
          latitudeExtractor={m => m[0]}
          longitudeExtractor={m => m[1]}
          intensityExtractor={m => parseFloat(m[2])} />
      </Else>
      </If>
      <TileLayer {...tileLayer} />
      <TileLayer
        url="/tiles-dc34-lvcc/{z}/{x}/{y}.png"
        attribution=""
        maxZoom={22}
        bounds={lvccTileBounds}
      />
  </>
  );
}
export default MapGuts;
